export default __webpack_public_path__ + "static/media/logo.6045e4ec.svg";